import Logo from '@/components/SideBar/Logo'
import { GetProjectShareContent, getUserInfo } from '@/model/reference'
import { GetQueryValue } from '@/utils/common'
import { Spin } from '@arco-design/web-react'
import React, { useEffect } from 'react'

function QuickLoginAuth() {
  useEffect(() => {
    const token = getCookie('access_token')
    window.location.href = `https://ias.zgbjds.com/?quickLogin=${token}`
  }, [])

  const getCookie = (name) => {
    let matches = document.cookie.match(
      new RegExp(
        '(?:^|; )' +
          name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
          '=([^;]*)',
      ),
    )
    return matches ? decodeURIComponent(matches[1]) : undefined
  }
  return (
    <div
      className={'pageLayout'}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}>
      <div
        style={{
          position: 'fixed',
          top: '-20px',
          left: '20px',
        }}>
        <Logo></Logo>
      </div>
      <Spin size={30} />
      <span style={{ marginLeft: '10px', marginTop: '-5px', fontSize: '22px' }}>
        登录验证中...
      </span>
    </div>
  )
}

export default QuickLoginAuth
